module.exports = __webpack_public_path__ + "static/media/list-black.4dd9cb28.svg";